var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.518233 0.77735C0.296715 0.445072 0.534911 0 0.934259 0H7.06574C7.46509 0 7.70328 0.445073 7.48177 0.77735L4.41603 5.37596C4.21811 5.67283 3.78189 5.67283 3.58397 5.37596L0.518233 0.77735Z",
    fill: "#8F90A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrowDown);
export default __webpack_public_path__ + "static/media/Sorting_arrow_down.726c68b8c10bed67e0008dc473aaad7b.svg";
export { ForwardRef as ReactComponent };